<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="red"
            x-small
            @click.stop=""
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-map-marker-multiple
            </v-icon>
          </v-btn>
        </template>
        <span>View Office Location</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Employee Office Locations"
      text="List of Employee's Office Location Records"
      class="mb-0"
    >
      <v-container v-if="dialog && !loading">
        <v-row class="py-0">
          <v-col>
            <span class="font-weight-bold font-16">
              Office Locations
            </span>
            <employee-profile-job-office-location-dialog-update
              v-if="$hasPermissionTo(['update employee office locations']) && !isMyProfile && !isResigned"
              :employee-uid="employeeUid"
              :employee-office-locations="employeeOfficeLocations"
              @updated="loadData()"
            />
          </v-col>
        </v-row>
        <v-data-table
          v-if="employeeOfficeLocations.length > 0"
          :headers="headings"
          :items="employeeOfficeLocations"
          disable-pagination
          hide-default-footer
          dense
          class="mb-0"
          :style="`border:1px solid rgba(0,0,0,.12)`"
        >
          <template v-slot:item.address="{ item }">
            <div>  
              <span>
                {{ item.address.length > 0 ? item.address : '-' }}
              </span>
            </div>
          </template>
        </v-data-table>
        <v-row 
          v-else
          align="center"
          justify="center"
        >
          <span> No data available</span>
        </v-row>
      </v-container>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileJobOfficeLocationDialogUpdate: () => import('@/components/hris/employee/profile/job/office-location/DialogUpdate'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headings: [
          {
            text: 'Office Name', 
            sortable: false, 
            value: 'name',
            divider: true,
          },
          {
            text: 'Address',
            sortable: false,
            value: 'address',
            divider: true,
            align: 'left',
          }, 
          {
            text: 'Latitude', 
            sortable: false, 
            value: 'latitude',
            divider: true,
            align: 'right',
          },
          {
            text: 'Longitude',
            sortable: false,
            value: 'longitude',
            divider: true,
            align: 'left',
          },             
        ],
        employeeOfficeLocations: [],
        cities: [],
        states: [],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loading = true

        Promise.all([
          this.$api.cities().list(),
          this.$api.states().list(),
        ])
          .then(([cities, states]) => {
            this.cities = cities.data
            this.states = states.data

            this.loadData()
          })
      },
    },
    methods: {
      loadData () {
        this.loading = true
        
        this.$api.employeeOfficeLocations().list(this.employeeUid)
          .then(res => {
            this.employeeOfficeLocations = res.data.map(office => {
              return {
                id: office.office_location.id,
                name: office.office_location.name,
                latitude: office.office_location.latitude,
                longitude: office.office_location.longitude,
                address: this.constructAddress(office.office_location),
              }
            })
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      constructAddress (office) {
        return this.checkStringHasComma(office.address_line_one ? office.address_line_one + ', ' : '') +
          this.checkStringHasComma(office.address_line_two ? office.address_line_two + ', ' : '') +
          this.checkStringHasComma(office.address_line_three ? office.address_line_three + ', ' : '') + 
          (office.postcode ? office.postcode : '') + 
          (office.city_id ? ' ' + (this.getCity(office.city_id).name) : '') + (office.state_id ? ', ' + (this.getState(office.state_id).name) : '')
      },
      checkStringHasComma (string) {
        if (string) {
          if (string.charAt(string.length - 1) === ',') {
            return string.substring(0, string.length - 1)
          }
        }
        return string
      },
      getCity (cityId) {
        if (isNaN(parseInt(cityId))) return null
        return this.cities.find(city => {
          return city.id === parseInt(cityId)
        })
      },
      getState (stateId) {
        if (isNaN(parseInt(stateId))) return null
        return this.states.find(state => {
          return state.id === parseInt(stateId)
        })
      },
      // toggleInfoWindow (marker, index) {
      //   this.infoWindowPos = marker.position
      //   this.infoOptions.content = marker.name

      //   if (this.currentMidx === index) {
      //     this.infoWinOpen = !this.infoWinOpen
      //   } else {
      //     this.infoWinOpen = true
      //     this.currentMidx = index
      //   }
      // },
    },
  }
</script>

<style scoped>
  .font-16{
    font-size:16px;
  }
</style>
